import { routes } from 'constants/routes';
import { CardInfoLink, Col, MoneyIcon, Row, Container } from '@ag1/ui';

type ReferFriendProp = {
  content: {
    text: string;
    title: string;
  };
};

export const ReferFriendCard = ({ content }: ReferFriendProp) => (
  <Container>
    <Row>
      <Col span={{ xs: 12, ssm: 6 }}>
        <CardInfoLink
          variant={{ xxs: 'mobile', s: 'desktop' }}
          title={content.title}
          text={content.text}
          path={routes.refFriend}
          icon={<MoneyIcon />}
        />
      </Col>
    </Row>
  </Container>
);
